import type { AxiosError } from 'axios';

export interface BookingConflictWarning {
  resource: 'dentist' | 'chair' | 'clinicHours' | 'staffSchedule';
  mode: 'block' | 'warn' | 'allow';
  conflictingAppointmentId?: string;
  message: string;
}

export interface BookingWarningsErrorBody {
  success?: boolean;
  message?: string;
  code?: string;
  data?: {
    warnings?: BookingConflictWarning[];
    blockers?: BookingConflictWarning[];
  };
}

export const isBookingWarningsError = (
  err: unknown
): err is AxiosError<BookingWarningsErrorBody> => {
  const axiosError = err as AxiosError<BookingWarningsErrorBody>;
  return (
    axiosError?.response?.status === 409 &&
    axiosError.response.data?.code === 'BOOKING_WARNINGS'
  );
};

export const getBookingWarningMessages = (err: unknown): string[] => {
  if (!isBookingWarningsError(err)) return [];
  const warnings = err.response?.data?.data?.warnings ?? [];
  return warnings.map((w) => w.message).filter(Boolean);
};
